<template>
  <!-- D : 판매종료시 is-card-soldout 추가 -->
  <div class="c-product-card type-horizontal">
    <div class="c-checkbox type-small">
      <input
        type="checkbox"
        :id="'mo-basket-chk-' + index"
        name="mo-basket-group1"
        :checked="checkedValue"
        @change="toggleItem()"
      />
      <label :for="'mo-basket-chk-' + index">
        <span class="sr-only">상품선택</span>
      </label>
    </div>
    <div class="product-thumb">
      <button type="button" class="thumb-button" @click="openProdInfoPop(item)">
        <div class="product-img">
          <img
            class="no-image"
            v-if="isNoPcImage"
            src="@/assets/images/common/img_no_product.svg"
            alt="No Image"
          />
          <img
            v-else
            :src="imageFilePath"
            alt=""
            @error="() => (imageErrorYn = true)"
          />
        </div>
        <div class="thumb-bottom">
          <p class="text">제품상세</p>
          <i class="c-icon icon-plus"></i>
        </div>
      </button>
      <!-- D : class="btn-favorite"에 클릭시 is-active 토글해주세요. -->
      <button
        type="button"
        :class="['btn-favorite', { 'is-active': item.cntsStrgYn === 'Y' }]"
        @click="keepItem(item)"
      >
        <i class="c-icon icon-star"></i>
        <span class="sr-only">장바구니</span>
      </button>
      <!-- 찜하기 안내 -->
      <div class="c-popover-detail type-small type-star" :class="popoverStyle">
        <div class="text">
          제품을 장바구니에<br />
          계속 보관할 수 있습니다.
        </div>
      </div>
    </div>
    <div class="product-info">
      <div v-show="!productBadgeEmptyYn" class="c-product-badge">
        <span v-if="item.setgdYn === 'Y'" class="badge type-skyblue">
          SET 제품
        </span>

        <span v-if="item.zzlqdCls == 'A'" class="badge type-purple">
          주제
        </span>
        <span v-if="item.zzlqdCls == 'B'" class="badge type-mint">
          경화제
        </span>
        <span v-if="item.zzlqdCls == 'C'" class="badge type-blue">
          경화촉진제
        </span>
        <span v-if="item.zzlqdCls == 'D'" class="badge type-violet">
          회석제
        </span>

        <span v-if="item.zzlqdtyCls == 'A'" class="badge type-olive">
          1액형
        </span>
        <span v-if="item.zzlqdtyCls == 'B'" class="badge type-olive">
          2액형
        </span>
        <span v-if="item.zzlqdtyCls == 'C'" class="badge type-olive">
          3액형
        </span>
      </div>
      <div class="c-product-category">
        <span class="path">{{ item.prodh1t }}</span>
        <span class="path">{{ item.prodh2t }}</span>
        <span class="path">{{ item.prodh3t }}</span>
      </div>
      <div class="product-code">{{ item.matnr }}</div>
      <strong class="product-name">{{ item.zzmaktx }}</strong>
      <div class="counter-box">
        <!-- D : 판매종료일때 class="is-soldout" 추가 후 각 form에는 disabled 추가해주세요. -->
        <div class="c-counter">
          <button
            type="button"
            class="btn-minus"
            :disabled="item.goodsQty <= 1"
            @click="() => item.goodsQty--"
          >
            <i class="c-icon icon-minus size-xxsmall"></i>
            <span class="sr-only">빼기</span>
          </button>
          <input
            type="number"
            title="수량입력"
            v-model="item.goodsQty"
            ref="myInput"
            @mousedown="handleMouseDown"
          />
          <button type="button" class="btn-plus" @click="() => item.goodsQty++">
            <i class="c-icon icon-plus-black size-xxsmall"></i>
            <span class="sr-only">더하기</span>
          </button>
        </div>
      </div>
      <div class="info-bottom">
        <p class="price">
          <strong class="system">{{
            Number(item.kbetr * item.goodsQty).toLocaleString()
          }}</strong
          >원
        </p>
        <div class="c-btn-area type-product">
          <button
            type="button"
            class="c-mo-button type-primary"
            @click.stop="() => emit('ordertemp', item)"
          >
            <span class="bold">바로 주문</span>
          </button>
        </div>
      </div>
    </div>
    <!-- D : 판매종료 dim -->
    <div class="card-dim">
      <p class="text">담당영업사원 통한 주문품 주문건</p>
      <i class="c-icon icon-check-circle"></i>
    </div>
    <!-- // D : 판매종료 dim -->
  </div>
  <!-- // D : 판매종료시 is-card-soldout 추가 -->
</template>

<script setup>
import { onMounted, ref, defineProps, defineEmits, computed, watch } from "vue";
import * as cmApi from "@/api/cmApi";
import Utils from "@/js/utils";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
  index: {
    type: Number,
    require: true,
  },
  checked: {
    type: Boolean,
    require: true,
  },
});

const emit = defineEmits(["checked", "detail", "ordertemp", "item"]);

const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
const item = ref({ ...props.item, popoverFlag: false }); // 제품
const imageErrorYn = ref(false);
const myInput = ref(null);
const checkedValue = computed({
  get: () => props.checked,
  set: (value) => emit("checked", value),
});
const popoverStyle = ref(null);

onMounted(() => {});

watch(
  () => props.item,
  (newValue) => {
    item.value = { ...newValue, popoverFlag: false };
  }
);

// 제품 상세 팝업
function openProdInfoPop(item) {
  emit("detail", item);
}

// 제품 수량 입력
watch(
  () => item.value.goodsQty,
  (newQty, oldQty) => {
    if (newQty < 1) {
      item.value.goodsQty = 1;
    } else if (newQty > 99999) {
      item.value.goodsQty = oldQty;
    } else {
      item.value.goodsQty = newQty;
    }
    updateItemQuantity(item.value.goodsSn, item.value.goodsQty);
  }
);

// 제품 수량 변경 API
async function updateItemQuantity(goodsSn, goodsQty) {
  const param = {
    goodsSn: goodsSn,
    goodsQty: goodsQty,
    cntsStrgYn: item.value.cntsStrgYn,
  };
  const res = await cmApi.updateUserBasketProd(param);
  if (res.resultCode === 200) {
    emit("item", item.value);
  }
}

// 계속담아두기
async function keepItem(item) {
  if (!item.popoverFlag) {
    item.popoverFlag = true;
    popoverStyle.value = "is-open";
    setTimeout(() => {
      popoverStyle.value = "";
    }, 3000);
  }
  item.cntsStrgYn = item.cntsStrgYn === "Y" ? "N" : "Y";
  const param = {
    goodsSn: item.goodsSn,
    goodsQty: item.goodsQty,
    cntsStrgYn: item.cntsStrgYn,
  };
  await cmApi.updateUserBasketProd(param);
}

// 체크박스
function toggleItem() {
  checkedValue.value = !checkedValue.value;
}

const productBadgeEmptyYn = computed(() => {
  return (
    item.value.setgdYn !== "Y" &&
    item.value.zzlqdCls !== "A" &&
    item.value.zzlqdCls !== "B" &&
    item.value.zzlqdCls !== "C" &&
    item.value.zzlqdCls !== "D" &&
    item.value.zzlqdtyCls !== "A" &&
    item.value.zzlqdtyCls !== "B" &&
    item.value.zzlqdtyCls !== "C"
  );
});

const isNoPcImage = computed(() => {
  return (
    Utils.isBlank(item.value.filePath) ||
    Utils.isBlank(item.value.physFileNm) ||
    imageErrorYn.value
  );
});

const imageFilePath = computed(() => {
  return FILE_CDN_URL + "/" + item.value.filePath + "/" + item.value.physFileNm;
});

const handleMouseDown = (event) => {
  event.preventDefault();
  myInput.value?.focus();
  myInput.value?.select();
};
</script>
